import React from 'react';
import {InnerRevenuesPage} from './inner-revenues-page';

export const CommonRevenuesPage: React.FC = () => {
  return <InnerRevenuesPage />;
};
